export default __webpack_public_path__ + "static/Parkinglot-a21d481d4d190f38b4c354b22dcb1d76.png";